import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  addPrice() {
    const template = this.templateTarget
    const newRow = template.content.cloneNode(true)
    this.containerTarget.appendChild(newRow)
  }

  removePrice(event) {
    const row = event.target.closest('[data-price-row]')
    const container = this.containerTarget
    
    if (container.querySelectorAll('[data-price-row]').length > 1) {
      row.remove()
    } else {
      alert('Il faut au moins un tarif.')
    }
  }
}
